import { FormEvent } from "react"
import { Head, Link, useForm, usePage } from "@inertiajs/react"
import { AuthShell } from "@/components/AuthShell"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

import type { PageProps } from "@/types/inertia"

export default function RequestAccess() {
  const { props } = usePage<PageProps>()
  const form = useForm({ email: "", company: "" })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post("/request-access")
  }

  const errors = props.errors ?? {}

  return (
    <>
      <Head title="Request access">
        <meta
          name="description"
          content="Ask a FloorCore admin for a FloorCore Measure login. Accounts are created by invite."
        />
        <meta property="og:title" content="Request access" />
        <meta
          property="og:description"
          content="Ask a FloorCore admin for a FloorCore Measure login. Accounts are created by invite."
        />
      </Head>
      <AuthShell
        footer={
          <>
            Already have an account? <Link href="/login">Log in</Link>
          </>
        }
      >
        <h2 className="auth-title">Request access</h2>
        <p className="mt-1.5 text-sm text-ink-muted">
          Internal tool — this goes to a FloorCore admin, who will send you an
          invite.
        </p>

        {props.flash?.alert && (
          <p className="mt-4 text-sm text-danger-display">{props.flash.alert}</p>
        )}

        <form onSubmit={submit} className="mt-4 space-y-4">
          <div className="space-y-1.5">
            <label htmlFor="email">Work email</label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              autoFocus
              required
              placeholder="you@company.com"
              aria-invalid={!!errors.email}
              value={form.data.email}
              onChange={(e) => form.setData("email", e.target.value)}
            />
            {errors.email && (
              <p className="text-xs text-danger-display">{errors.email}</p>
            )}
          </div>
          <div className="space-y-1.5">
            <label htmlFor="company">Company</label>
            <Input
              id="company"
              type="text"
              autoComplete="organization"
              placeholder="Flooring dealer or contractor"
              value={form.data.company}
              onChange={(e) => form.setData("company", e.target.value)}
            />
          </div>
          <Button type="submit" className="w-full" disabled={form.processing}>
            Send request
          </Button>
        </form>
      </AuthShell>
    </>
  )
}
